export var PopoverCloseSource;
(function (PopoverCloseSource) {
    PopoverCloseSource[PopoverCloseSource["Click"] = 0] = "Click";
    PopoverCloseSource[PopoverCloseSource["EscapeKeypress"] = 1] = "EscapeKeypress";
    PopoverCloseSource[PopoverCloseSource["FocusOut"] = 2] = "FocusOut";
    PopoverCloseSource[PopoverCloseSource["ScrollOut"] = 3] = "ScrollOut";
})(PopoverCloseSource || (PopoverCloseSource = {}));
//# sourceMappingURL=types.js.map